<template>
  <div class="flex-grow-1">
    <v-checkbox
      :disabled="locationList.length === 0 || loading"
      :false-value="false"
      :true-value="true"
      :indeterminate="loading"
      indeterminate-icon="fa fa-spinner"
      type="boolean"
      label="Structure is Locked"
      v-model="structureIsLocked"
    ></v-checkbox>
  </div>
</template>

<script>
import { upperFirst } from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  computed: {
    structureIsLocked: {
      get() {
        return this.getStructureStatus;
      },
      set(val) {
        return this.toggleStructureLock(val);
      },
    },
    ...mapGetters({
      getStructureStatus: "organizationStatus/getStructureStatus",
    }),
    ...mapState({
      canEditOrganization: state =>
        state.session.user.permission.structureApp.updateOrganization,
      departmentList: state => state.department.list,
      locationList: state => state.location.list,
      organization: state => state.organization.record,
      organizationId: state => state.session.user.organizationId,
    }),
  },
  async created() {
    this.loading = true;
    try {
      await Promise.all([
        this.getDepartmentList({ reload: false }),
        this.getLocationList({ reload: false }),
      ]);
    } catch (e) {
      console.error(e);
    }
    this.loading = false;
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async toggleStructureLock(val) {
      this.loading = true;
      await Promise.all([
        this.updateLockedStatus("department", val),
        this.updateLockedStatus("location", val),
      ]);
      this.loading = false;
      this.$emit("structureLockToggled");
    },
    async updateLockedStatus(entity, val) {
      const entityList = this[`${entity}List`];
      const fetchList = `get${upperFirst(entity)}List`;
      const promiseArray = entityList.map(record => {
        return this[`${entity}Update`]([
          record[`${entity}Id`],
          { locked: val },
        ]);
      });

      try {
        // Update each entity's locked status
        await Promise.all(promiseArray);
        await this[fetchList]();
        this.$notifySuccess({
          message: `${val ? "Locked" : "Unlocked"} ${entity}s`,
        });
      } catch (e) {
        console.error(e);
        this.$notifyError({ message: `Error locking ${entity}s` });
      }
    },
    updateLoadingStatus(status) {
      this.$emit("updateLoadingStatus", status);
    },
    ...mapActions({
      getDepartmentList: "department/list",
      getLocationList: "location/list",
      departmentUpdate: "department/update",
      locationUpdate: "location/update",
    }),
  },
};
</script>

<style scoped>
::v-deep .fa-spinner {
  animation: spinner 2s infinite linear;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
</style>
